export const WIDGET_TYPE = {
  ProductWidget: "ProductWidget",
  BannerWidget: "BannerWidget",
};

export const SPECIFIC_WEB_STORE = {
  DIGIKALA: 1,
};

export const WEB_STORE_AMOUNT_TYPE = {
  OriginalAmount: 1,
  AmountWithDiscount: 2,
};

export const LOG_TYPE = {
  WIDGET_INIT: "WIDGET_INIT",
  WIDGET_EMPTY: "WIDGET_EMPTY",
  WIDGET_VIEW: "WIDGET_VIEW",
  WIDGET_SERVER_ERROR: "WIDGET_SERVER_ERROR",
  WIDGET_API_ERROR: "WIDGET_API_ERROR",
};
export const LOCAL_KEY = "_aflwlog";
